var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusTableProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_671_24107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_671_24107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27023 9.5C5.05124 9.5 4.8682 9.40196 4.7211 9.20588C4.5737 9.0098 4.5 8.77451 4.5 8.5C4.5 8.21569 4.5737 7.97784 4.7211 7.78647C4.8682 7.59549 5.05124 7.5 5.27023 7.5L10.7298 7.5C10.9488 7.5 11.132 7.59549 11.2794 7.78647C11.4265 7.97784 11.5 8.21569 11.5 8.5C11.5 8.77451 11.4265 9.0098 11.2794 9.20588C11.132 9.40196 10.9488 9.5 10.7298 9.5H5.27023Z",
    fill: "#878787"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusTableProducts);
export default __webpack_public_path__ + "static/media/minus-table-products.a5c8a2b8515834891c09000569bc844a.svg";
export { ForwardRef as ReactComponent };